@if (allClients(); as allClients) {
	@if (allClients.length > 0) {
		<div>
			<nz-select
				[nzMaxTagCount]="3"
				[nzMaxTagPlaceholder]="tagPlaceHolder"
				nzMode="multiple"
				nzPlaceHolder="Please select"
				[(ngModel)]="selectedClientUuids"
				(ngModelChange)="onSelectionChange($event)"
			>
				@for (client of allClients; track client) {
					<nz-option
						[nzLabel]="client.active_text?.name + ' (' + client.subdomain + ')'"
						[nzValue]="client.uuid"
					></nz-option>
				}
			</nz-select>
			<ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
		</div>
	}
}
